<div class="npdc-title">
  <h1>Plankton occurrences</h1>
</div>

<p>
  This is the occurrence data associated with the
  <a routerLink="/dataset/{{ planktonDatasetId }}"> Marine plankton biodiversity </a>
  dataset.
</p>

<div class="npdc-search">
  <div class="npdc-search__input">
    <div class="npdc-search__input__prefix">
      <mat-icon>search</mat-icon>
    </div>
    <input
      type="search"
      placeholder="Search in occurrences …"
      [value]="q()"
      (search)="onSearchEvent($event)"
      (keydown.enter)="onSearchEvent($event)"
    />
  </div>
  <button mat-icon-button (click)="openFilterDialog()" matTooltip="Advanced search">
    <mat-icon>tune</mat-icon>
  </button>
  <button
    mat-icon-button
    matTooltip="Download …"
    [matMenuTriggerFor]="downloadMenu"
    [disabled]="!response.hasValue() || !response.value().items.length"
  >
    <mat-icon>download</mat-icon>
  </button>
</div>

@if (activeChips()) {
  <mat-chip-set>
    @for (chip of activeChips(); track chip.id) {
      <mat-chip highlighted>
        {{ chip.label }}
        <mat-icon matChipRemove (click)="onFilterRemove(chip)">cancel</mat-icon>
      </mat-chip>
    }
  </mat-chip-set>
}

@let j = geojsonData();
@if (j && j.features.length > 0) {
  <p>
    <mat-card class="npdc-leaflet" appearance="outlined">
      <app-leaflet-group [geometry]="j" [readonly]="true" [height]="'250px'" />
    </mat-card>
  </p>
}

<app-list [resource]="response">
  @if (!response.error()) {
    <mat-nav-list>
      @for (occ of this.response.value()?.items; track occ.id) {
        @let ev = occ.event;
        <a mat-list-item routerLink="/plankton/occurrence/{{ occ.id }}">
          <mat-icon matListItemIcon>bubble_chart</mat-icon>
          <span matListItemTitle>
            {{ occ.content.scientificName }}
            @if (occ.content.lifeStage) {
              / {{ occ.content.lifeStage }}
            }
          </span>
          <span matListItemLine>
            @if (ev) {
              {{ ev | eventTitle }}
            } @else {
              N/A
            }
          </span>
          <span matListItemLine>
            @if (ev) {
              {{ ev | eventAbstract }}
            } @else {
              N/A
            }
          </span>
        </a>
      }
    </mat-nav-list>

    <mat-paginator
      showFirstLastButtons
      (page)="onPageEvent($event)"
      [length]="count()"
      [pageIndex]="page()"
      [pageSize]="pageSize()"
      [pageSizeOptions]="[10, 20, 50, 100]"
    >
    </mat-paginator>
  }
</app-list>

<mat-menu #downloadMenu>
  <a mat-menu-item href="{{ csvDownloadURL() }}" target="_blank"> Download as csv </a>
  <a mat-menu-item href="{{ csvDownloadURL() }}&verbose=true" target="_blank">
    Download as csv (verbose)
  </a>
</mat-menu>
